import { useEffect, useLayoutEffect } from 'react';

/* Returns a generic hook for useEffect (works with browser and server-side) */
const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

export default useIsomorphicLayoutEffect;
